<div class="host-hour-room-calendar">
  <div class="hour-room-calendar-container" (dblclick)="dbClick()">
    <div class="time-lines-container" >
      <div 
        class="time-line-item" 
        *ngFor="let time of listOfTimeline">
        <div class="time">{{ time | date:'HH:mm' }}</div>
        <div class="line"></div>
      </div>

    </div>
    
    <div class="orders-container">
      <div 
        class="order-item" 
        nz-popover
        *ngFor="let order of listOfAllReservation"
        (click)="order.type === 'hour_reservation' ? clickReservation(order.reservation_code) : null"
        [ngStyle]="order.style"
        [nzPopoverTitle]="null"
        [nzPopoverContent]="order.type === 'hour_reservation' ? popContent : null">
        <div 
          class="order-item-inner"
          [class.selected]="order.reservation_code === selectedReservation"
          [class.reservation]="order.type !== 'hour_reservation'"
          [style.background-color]="order.type === 'hour_reservation' ? channelColorMap[order.handmade_channel]?.bg_color || '#b9b9b9' : '#e9e9e9'">
          <span class="client-name">
            {{ order?.client?.name }}
          </span>
          <span *ngIf="order.type === 'checkin_reservation'">{{ "order.check_in" | translate }}{{ order.start | date: 'HH:mm' }}</span>
          <span *ngIf="order.type === 'checkout_reservation'">{{ "order.check_out" | translate }}{{ order.end | date: 'HH:mm' }}</span>
          <ng-template #popContent>
            <p class="name">{{ order?.client?.name }}</p>
            <p class="time">{{ "calendar.pop.hour_reservation" | translate }}{{ order.hour_reservation_start_time | slice:0:5 }} ~ {{ order?.hour_reservation_end_time | slice:0:5 }}</p>
          </ng-template>
        </div>
      </div>

    </div>
  </div>
</div>
